import { IsInt, IsOptional, IsString, MaxLength } from 'class-validator';

export class OrderUpdateShortNoteRequest {
    @IsInt()
    public orderId: number;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public shortNote?: string;

    constructor(data?: Partial<OrderUpdateShortNoteRequest>) {
        this.orderId = data?.orderId;
        this.shortNote = data?.shortNote;
    }
}
